import styled from 'styled-components'


const ImagenAgents = styled.img`
    width:8rem;
    height:8rem;
    background: #ffff;
    border-radius:10px;
    padding:5px 5px;
`

export default ImagenAgents;